// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.full-height {\n  position: relative;\n  height: 100%;\n}\n.el-dialog__body {\n  padding-top: 0px;\n}\n.el-table .success-row {\n  background: #f0f9eb;\n}\n.el-table__expanded-cell,\n.el-table__expanded-cell:hover {\n  background-color: cornsilk !important;\n}\n.el-table__expand-icon {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
